export default __webpack_public_path__ + "static/media/kbs.10f2678e.jpg";